import { Box, Grid } from "@mui/material";
import NavCard from "components/NavCard";
import useGlobalContext from "hooks/globalData";
import useTitle from "hooks/useTitle";
import { useIntl } from "react-intl";

const DynamicMenuPage = () => {
  const { formatMessage: t } = useIntl();
  const { menusUrl, menuItemsUrl } = useGlobalContext();

  useTitle(t({ id: "menubarDynamicMenu" }));

  return (
    <Box my={4}>
      <Grid container spacing={4}>
        <Grid item xs={12} sm={4}>
          <NavCard title={t({ id: "menubarMenu" })} url={menusUrl()} />
        </Grid>
        <Grid item xs={12} sm={4}>
          <NavCard title={t({ id: "menubarMenuItems" })} url={menuItemsUrl()} />
        </Grid>
      </Grid>
    </Box>
  );
};

export default DynamicMenuPage;
